import { Component, inject } from "@angular/core";
import { StatsigClientService } from "@core-services/statsig/statsig.service";
import { Tradable } from "@models/interfaces/tradable";
import { CustomModal } from "@modules/core/components/base-modals";
import { isStockType } from "@modules/trade/helpers/helper";

@Component({
	templateUrl: "./add-watchlist-modal.component.html",
	styleUrls: ["./add-watchlist-modal.component.scss"],
	standalone: false
})
export class AddWatchListModalComponent extends CustomModal {
	public selectedAssets: Tradable[] = [];
	public existingAssetIds: string[]; // input that tells us which assets should be filtered out of the list

	private statsigService = inject(StatsigClientService);

	public constructor() {
		super();
	}

	// -------------------- CUSTOM FILTER FOR INFINITE SCROLL LIST
	//TODO: legacy approach not performative, this should have been
	public filterTradableList = (tradables: Tradable[]): Tradable[] => {
		const filteredTradables = this.filterAllStock(tradables);

		return this.existingAssetIds?.length > 0
			? filteredTradables.filter((tradable) => !this.existingAssetIds.includes(tradable.getId()))
			: filteredTradables;
	};
	// --------------------

	public getSelectedLength(): string {
		if (this.selectedAssets.length === 0) {
			return "";
		}
		return "(" + this.selectedAssets.length + ")";
	}

	public addToFavourites(): void {
		super.close(this.selectedAssets);
	}

	private filterAllStock(tradables: Tradable[]): Tradable[] {
		return tradables.filter((t) => {
			return !isStockType(t.getAssetGroupName());
		});
	}
}
